export default __webpack_public_path__ + "static/media/dusk.374e85be.jpg";